'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Bars = require('./Bars');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Bars).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Bars/index.js
// module id = 1116
// module chunks = 1